import React from 'react';

const ProductCard = ({ product }) => {
  const priceText = product.min_price ? `$${(product.min_price.amount/100).toFixed(2)} ${product.min_price.currency}` : 'Free';
  const isFree = !product.min_price;
  return (
    <a className="book-card" href={`/eBookstore/${product.slug}`}>
      <div className="book-image-container">
        <img src={product.cover_url || ''} alt={product.title} className="book-image" />
        {isFree && <span className="badge-free">Free</span>}
      </div>
      <div className="book-content">
        <h3>{product.title}</h3>
        <div className="book-meta">
          <span className="chip chip-lang">{product.language || '—'}</span>
          <span className="chip chip-level">{product.level || '—'}</span>
        </div>
        <div className="book-price-actions">
          <span className="book-price">{priceText}</span>
          <span className="details-link">View</span>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;
